// extracted by mini-css-extract-plugin
export default {"previewImage":"upload-preview_previewImage__A9yL8","outline":"upload-preview_outline__8sNmG"};